<template>
  <div style="height: 100%">   
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
    
    <div>
        <vx-card>
            <div class="vx-row mb-4">
                <div class="vx-col md:w-1/2 w-full">                    
                    <vs-button class="ml-auto mt-2" size="small" @click="gravar" color="success" v-if="temPermissaoAlterar">Gravar</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="excluir" v-show="isDeletable && temPermissaoAlterar" color="danger">Excluir</vs-button>            
                    <vs-button class="ml-4 mt-2" size="small" type="border" color="dark" @click="voltar">Voltar</vs-button>             
                </div>
            </div>                       
            <div class="vx-row">                
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Tipo</label>                     
                    <v-select                                               
                        :options="CONSTANTES_TIPO_GRUPO_CONTA" 
                        v-model="data_local.tipo"    
                        :clearable="false"
                        :reduce="r => r.data"     
                        style="z-index: 10000 !important;"                                                                    
                        class="v-select w-full">
                    </v-select>  
                </div>                 
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Nome</label>
                    <vs-input class="w-full" v-model="data_local.nome" :maxlength="255"/>   
                </div>                 
            </div>                           
        </vx-card>  
    </div>
    
  </div>
</template>

<script>
import axios from "@/axios.js"
import { CONSTANTES_TIPO_GRUPO_CONTA } from '@/constantesComboBox.js'
const URL_SERVLET = "/Grupoplanoconta";
const NAME_ROUTE_SEARCH = "cadastro-grupos-contas-pesquisar";

export default { 
  components: {  
    
  },      
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
        return { nome: null }
       }
    },
  },
  data() {
    return {        
        errorsValidacao: [],  
        data_local: JSON.parse(JSON.stringify(this.registroOriginal))        
    }
  },  
  created(){
        this.CONSTANTES_TIPO_GRUPO_CONTA = CONSTANTES_TIPO_GRUPO_CONTA;
  }, 
  mounted() {
    if (this.registroOriginal.hasOwnProperty('id')) {
          this.$vs.loading();
          this.findById();  
    } 
  },
  computed: {        
    isDeletable() {
       return this.data_local != null && this.data_local.hasOwnProperty("id");
    }, 
    isGestor() {
      return (this.$store.state.AppActiveUser.perfil === 'GESTOR' || this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA');
    },
    temPermissaoAlterar() {
        if ( this.isGestor ) {
            return true;
        } 

        if (this.data_local !== null && this.data_local.hasOwnProperty("id")) {
            if (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO' || this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER' 
                    || this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_PAGAR' ) {
                return true;
            }

            return false;
        } else {
            if (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO' || this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER' 
                    || this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_PAGAR' || this.$store.state.AppActiveUser.perfil === 'CRM'
                    || this.$store.state.AppActiveUser.perfil === 'CRM_CONTA_RECEBER') {
                return true;
            }

            return false;
        }        
    }
  },
  methods: {  
    
    findById() {       
        const params = new URLSearchParams();       
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "/recuperar", params, {              
            headers: {'Accept': 'application/json' }, credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                 this.data_local = response.data.Grupoplanoconta;                            
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    }, 
    excluir() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirRequest
        });
    },
    excluirRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();                        
        params.append('listaIds', this.data_local.id);   
                
        axios.post(URL_SERVLET + "/remover", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("error")) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.error, acceptText: 'OK'})
                } else {
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    gravar() {        
        if (this.formularioValido()) { 
            this.$vs.loading();
            const params = new URLSearchParams();    
            
            if (this.data_local.hasOwnProperty('id')) {
                params.append('id', this.data_local.id);    
            }
            
            params.append('tipo', this.data_local.tipo);            
            params.append('nome', this.data_local.nome);            

            axios.post(URL_SERVLET + "/gravar", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                    
                    this.$vs.loading.close()
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.Grupoplanoconta.erroOperacao) {                 
                        this.$vs.loading.close()       
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Grupoplanoconta.mensagemResultadoOperacao, acceptText: 'OK'})
                    } else {                        
                         this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                            text: response.data.Grupoplanoconta.mensagemResultadoOperacao,
                        });

                        this.data_local = response.data.Grupoplanoconta;  
                        this.findById();
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];
        
        if (!this.data_local.tipo) { this.errorsValidacao.push("Tipo obrigatório"); }
        if (!this.data_local.nome) { this.errorsValidacao.push("Nome obrigatório"); }
      
        if (!this.errorsValidacao.length) {
            return true;
        }   
        return false;
    },    
  }
}
</script>

<style scoped>  
  .vs__dropdown-menu {
    max-height: 80px;    
  }
</style>

<style scoped>
  .tabelaComScroll {      
      overflow: auto;  
      height: calc(100vh - 300px);
      position: relative;      
    } 
</style>